export default {"id":"e1222e3b","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}